{
  "add": "Ajouter",
  "add-barn-first-description": "Enregistrez d'abord les bâtiments d'élevage dans vos paramètres. Ensuite, vous pouvez enregistrer l'arrivée ici.",
  "add-cycle": "Ajouter un cycle",
  "add-day-old-chick-first-description": "Enregistrez d'abord une arrivée. Ensuite, vous pouvez enregistrer le départ ici.",
  "age": "L'âge",
  "amount": "Montant",
  "app": {
    "cycles": "Cycles",
    "deliveries": "Livraisons",
    "reports": "Rapports",
    "settings": "Paramètres",
    "products": "Produits",
    "farmer-insights": "Perspectives pour l'agriculteur",
    "advices": "Conseils et références",
    "feed-advice": "Conseils en matière d'alimentation",
    "reference-value-sheet": "Fiche de valeur de référence",
    "standard-reference-value-sheet": "Fiches de valeurs de référence standard",
    "reference-scheme": "Conseils sur les aliments de référence",
    "management": "Gestion",
    "performance": "Performance",
    "within-cycle-performance": "Performance à l'intérieur du cycle"
  },
  "farmer-insights": {
    "kpiGroups": {
      "TechnicalPerformance": "Performances techniques",
      "FinancialPerformance": "Performances financières",
      "ArrivalAndDeparture": "Arrivée et départ",
      "FeedConsumption": "Consommation d'aliments",
      "WellBeing": "Bien-être",
      "RevenueAndCost": "Recettes et coûts"
    },
    "description": "Des informations en temps réel sur l'état de votre exploitation !",
    "locations": "Localisation des sites",
    "location": "Localisation",
    "cycles": "Cycles",
    "barns": "Étables",
    "detail-level": "Niveau de détail",
    "display-type": "Affichage",
    "kpis-name": "ICP",
    "table": "Tableau",
    "chart": "Graphique",
    "kpi-selection": "Sélection des ICP",
    "aggregation": {
      "Sum": "Cumulatif",
      "Average": "Moyenne",
      "Min": "Min",
      "Max": "Max"
    },
    "custom-footers": {
      "end-total": "Total final",
      "same-period": "<Tenant> même période (lots:",
      "last-weeks": "<Tenant> dernières 10 semaines (lots:",
      "customer-average-selected-period": "Période moyenne sélectionnée par le client (lots :"
    },
    "no-data": {
      "title": "Pas de données d'observation disponibles",
      "description": "Les données sont affichées lorsqu'un ou plusieurs troupeaux sont disponibles."
    },
    "no-benchmark": "Données insuffisantes pour le déterminer (un minimum de 15 troupeaux est nécessaire).",
    "benchmark-title": "<Tenant>",
    "benchmark-selected-period": "période sélectionnée",
    "benchmark-last-weeks": "10 dernières semaines",
    "norm": "norme",
    "benchmark-settings": "Paramètres de référence",
    "settings": {
      "header": "Filtres",
      "title": "Paramètres de référence",
      "subtitle": "Ici, vous pouvez définir avec quelle référence vous souhaitez comparer vos troupeaux si vous n'êtes pas en mode \"détaillé\".",
      "selected-period-label": "Afficher l'indice de référence de <Tenant> pour la période sélectionnée",
      "last-weeks-label": "Afficher l'indice de référence de <Tenant> pour les 10 dernières semaines",
      "customer-average-selected-period-label": "Afficher la moyenne du client pour la période sélectionnée",
      "none": "Aucun",
      "select-multiple-benchmark-label": "Vous pouvez sélectionner plusieurs \"benchmarks\"",
      "select-one-benchmark-label": "Vous ne pouvez sélectionner qu'un seul \"benchmark\"",
      "non-detailed-view-label": "Vues non détaillées",
      "detailed-view-label": "Vues détaillées"
    },
    "reset-filters": "Rétablir la sélection des ICP",
    "to": "à",
    "maxPrintWarning": {
      "title": "Avertissement",
      "message": "Vous avez sélectionné plus que le nombre maximum d'ICP que vous pouvez imprimer. Seul le premier nombre d'ICP pouvant être imprimé sera affiché lors de l'impression. Nombre actuel de KPI possibles lors de l'impression :"
    },
    "kpis": {
      "DayOldChicks": "Nombre de poussins mises en place",
      "DayOldChicksPrice": "Prix montant des poussins d'un jour",
      "TotalDeparture": "Départ total",
      "DepartureWeight": "Poids au départ",
      "SlaughterWeight": "Poids d'abattage",
      "Revenue": "Recettes",
      "FeedBalance": "Consommation d'aliments",
      "FeedBalancePrice": "Montant de consommation des aliments ",
      "LossPercentage": "Pourcentage de mortalité",
      "ReplacementPercentage": "Pourcentage de remplacement",
      "FeedConversion": "Indice alimentaire",
      "FeedConversion1500": "Indice alimentaire 1500",
      "AverageWeightInGram": "Poids moyen",
      "WeightedAverageAgeInDays": "Âge moyen pondéré",
      "WeightedAverageGrowthPerDay": "Croissance",
      "ProductionNumber": "Ciffre de production",
      "DayOldChicksPerSquareMeter": "Nombre de poussins par m²",
      "FeedUsageInKgPerSquareMeter": "Consommation d'aliments par m²",
      "FeedConsumptionPricePer100Kg": "Montant de consommation alimentaire par 100 kg poids vife",
      "PaidAmountPerKg": "Recettes par kg",
      "NettoRevenue": "Montant marge poussin aliments",
      "NettoRevenuePerChick": "Marge poussin aliments par poussin",
      "NettoRevenuePerSquareMeterPerDay": "Marge poussin aliments par m² et par jour",
      "RejectionRate": "Déclassés comptés",
      "PricePerDayOldChick": "Montant par poussin d'un jour",
      "FeedBalanceMixProduct": "Consommation d'aliments composés",
      "FeedBalanceRawProduct": "Consommation d'aliments simples",
      "DeliveredKgPerSquareMeter": "kg livré par m²",
      "NettoRevenuePerSquareMeter": "Montant de marge poussin aliments par m²",
      "FeedConsumptionPerDeliveredKg": "Coûts d'alimentation par kg livré",
      "DayOldChicksWeight": "Poids du poussin",
      "WeightedHeelDermatitis": "Dermatite du talon pondéré",
      "WeightedFootpadLesionNonePercentage": "FPD pondéré 0",
      "WeightedFootpadLesionModeratePercentage": "FPD pondéré 1",
      "WeightedFootpadLesionSeverePercentage": "FPD pondéré 2",
      "TotalLoss": "Mortalité total",
      "WeightedFootpadLesionScore": "Score FPD pondéré",
      "FeedBalanceRawPrice": "Montant des aliments simples",
      "FeedBalanceMixPrice": "Montant des aliments composés",
      "PartialDeparture": "Nombres de poussins en désserage",
      "FullDeparture": "Nombres de poussins en chargement finale",
      "NettoProfitInclOtherCosts": "Bénéfice net",
      "DayOldChicksPriceExclDiscounts": "Prix d'arrivée des poussins hors réductions",
      "RevenueExclDiscounts": "Recettes hors remises",
      "FeedBalancePriceExclDiscounts": "Prix de la consommation d'aliments pour animaux hors remises"
    },
    "data-view-types": {
      "PerLocation": "Par lieu",
      "PerCycle": "Par lot",
      "PerCycleBarn": "Par lot Par étable",
      "PerLocationBarn": "Par étable"
    },
    "customer-average-selected-period": "Moyenne des clients période sélectionnée",
    "show-more": "Montrez plus",
    "show-less": "afficher moins"
  },
  "within-cycle-performance": {
    "advice_and_reference-value-sheet": "Conseils en matière d'alimentation et fiche de valeurs de référence",
    "kpi": "ICP",
    "kpis": {
      "IndoorTemperature": "Température intérieure",
      "IndoorHumidity": "Humidité intérieure",
      "MortalityPercentage": "Mortalité%",
      "FeedIntakePerChick": "Consommation d'aliments (par poussin)",
      "WaterIntakePerChick": "Consommation d'eau (par poussin)",
      "WeightGainPerChick": "Gain cotidien (par poussin)",
      "WaterToFeedRatio": "Rapport eau:alimentation",
      "FeedConversionRate": "Taux de conversion alimentaire\n",
      "LitterQuality": "Qualité de la litière",
      "LitterQualityCaked": "compacté",
      "LitterQualityLoose": "perte",
      "LitterQualityWet": "Humide",
      "BodyWeight": "Poids vife",
      "GrowthPrediction": "Prévision de croissance",
      "IndoorOutdoorTemperature": "Température intérieure / extérieure",
      "IndoorOutdoorHumidity": "Humidité intérieure / extérieure",
      "OutdoorTemperature": "Température extérieure",
      "OutdoorHumidity": "Humidité extérieure"
    },
    "no-data": "Pas de données disponibles."
  },
  "area": "Zone",
  "arrival-date": "Date d'arrivée",
  "avined": "Avancé",
  "balance": {
    "add-manual-delivery": "Ajouter une livraison",
    "balance-row": "Ligne d'équilibre",
    "barn-distribution": {
      "available-in-this-cycle": "Disponible dans ce cycle",
      "change-flock-allocation": "Changement de place du lot",
      "currently": "Actuellement :",
      "delivery-line-info": "livraison Information",
      "flock-allocation": "Lieu du lot\n",
      "kg-per-chick": "kg/poussin d'un jour",
      "of-which-remaining": "Dont le reste",
      "total-should-be": "La somme de toutes les quantités doit être ",
      "totally-delivered": "Livré total",
      "usage-in-kg": "Utilisation (kg)",
      "usage-in-other-cycles": "Utilisation dans d'autres cycles",
      "usage-in-this-cycle": "Utilisation dans le cadre de ce cycle",
      "total": "Total",
      "totalRaw": "Total des aliments simples",
      "totalCompound": "Aliments composés totaux"
    },
    "consumption": "Consommation (kg)",
    "delivery-date": "Date de livraison",
    "empty-day-old-chick-description": "Enregistrez d'abord une arrivée. Ensuite, vous pouvez ajouter les lignes des livraisons ici.",
    "empty-day-old-chick-title": "Pas de livraisons",
    "empty-description": "Cliquez sur \"Recalculer\" pour afficher la livraison total",
    "empty-title": "Aucune ligne d'équilibre n'a été trouvée",
    "manual-add": "Manuel",
    "multiple-deliveries": "Livraisons multiples",
    "price": "Prix",
    "product": "Produit",
    "quantity": "Quantité (kg)",
    "recalculate": "Recalculer",
    "recalculate-warning": {
      "text": "Toutes les livraisons de fourrage pour le cycle en cours seront rechargées. Toutes les nouvelles livraisons sont ajoutées. Toutes les quantités restantes sont remises à zéro.",
      "title": "Êtes-vous sûr de vouloir recalculer ?"
    },
    "remainder": "Reste (kg)",
    "remainder-greater-than-quantity": "Le reste ne peut pas être supérieur à la quantité.",
    "remainder-less-than-zero": "Le reste ne peut être inférieur à 0.",
    "remainder-less-than-quantity": "Le reste ne peut être inférieur à la quantité.",
    "remainder-greater-than-zero": "Le reste ne peut pas être supérieur à 0.",
    "remainder-other-than-zero": "Le reste ne peut être différent de 0.",
    "remainder-NaN": "Le reste n'est pas un nombre valide.",
    "pending-changes-warning": {
      "title": "Modifications non sauvegardées",
      "message": "Vous avez des changements non sauvés dans votre balance.",
      "confirmText": "Continuer sans sauvegarder",
      "cancelText": "Annuler"
    },
    "save-confirm": {
      "title": "Sauvegarder l'équilibre",
      "text": "L'équilibre n'a pas encore été finalisé. En sauvegardant et en rendant final, vous pouvez donner au l'équilibre le statut \"final\". Si l'équilibre n'est pas encore complet, il convient de choisir \"sauvegarder\". Vous pouvez ainsi sauvegarder l'équilibre avec le statut \"préliminaire\".",
      "alert": "Il est important de finaliser l'équilibre, car ce n'est qu'à ce moment-là que le cycle sera considéré comme complet dans les rapports."
    },
    "edit-confirm": {
      "title": "Modifier l'équilibre",
      "text": "Si vous choisissez de modifier l'équilibre, le statut de l'équilibre passera de \"final\" à \"préliminaire\". Vous pouvez alors apporter vos modifications et rendre l'équilibre à nouveau définitif.",
      "alert": "Il est important de finaliser à nouveau l'équilibre après les changements, car un tour avec un équilibre préliminaire ne sera pas considéré comme complet dans les rapports."
    },
    "not-finalized": {
      "title": "L'équilibre n'est pas encore finalisé",
      "message": "L'équilibre n'a pas encore été finalisé. L'option \"Sauvegarder et finaliser\" permet de finaliser immédiatement l'équilibre."
    },
    "save-and-finalize": "Sauvegarder et finaliser",
    "save": "Économiser",
    "edit": "Editer",
    "edit-balance": "Modifier l'équilibre",
    "delete-confirm": {
      "text": "La livraison sera alors supprimée de votre liste.",
      "title": "Êtes-vous sûr de vouloir supprimer cette livraison ?"
    },
    "has-empty-barns": {
      "title": "Lignes d'équilibrage défectueuses trouvées",
      "message": "Des lignes de solde ont été trouvées alors qu'aucune étable n'avait été définie. Ce problème sera résolu en recalculant la balance."
    },
    "barn-name": "Étable",
    "invoice-date": "Date de la facture",
    "invoice-number": "Numéro de facture",
    "delivery-number": "ID de livraison"
  },
  "balance-item": {
    "add-product": "Ajouter manuellement",
    "error-product-selected": "Sélectionner un produit",
    "no-products": "Aucun produit existant n'a été trouvé.",
    "product": "Produit"
  },
  "balance-item-delivery": {
    "amount": "Montant par étable",
    "current-usage": "Utilisation actuelle",
    "error-amount": "Saisir le montant",
    "error-no-amount": "Inscrivez le montant pour au moins une étable.",
    "remaining-of": "restant de"
  },
  "balance-item-manual": {
    "amount": "Montant par étable",
    "delivery-date": "Date de livraison",
    "error-amount": "Saisir le montant",
    "error-delivery-date": "Saisir la date de livraison",
    "error-no-amount": "Inscrivez le montant pour au moins une étable.",
    "error-price": "Indiquer le prix net",
    "error-product-title": "Saisir la description du produit",
    "error-supplier-name": "Saisir le nom du fournisseur",
    "error-vat": "Saisir le pourcentage de TVA",
    "price": "Prix net (hors TVA)",
    "product-title": "Description du produit",
    "product-type-multiple": "Produit mixte",
    "supplier-name": "Nom du fournisseur",
    "vat": "TVA"
  },
  "balance-summary": {
    "consumption-per-delivered-chick": "Consommation/Poulet livré",
    "final-stock": "Stock final (kg)",
    "initial-stock": "Stock initial (kg)",
    "title": "Résumé de l'équilibre",
    "total": "Consommation totale (kg)",
    "delivery-stock": "Livraison (kg)",
    "product": "Produit"
  },
  "barn": "Étable",
  "barn-item": {
    "area": "Surface",
    "error-name-duplicate": "Ce nom d'étable est déjà utilisé. Saisir un nom d'étable unique",
    "error-name-required": "Saisir le nom de l'étable",
    "error-surface-area": "Entrer la surface",
    "name": "Description de l'étable",
    "animal-group-barn-id": "Groupe d'animaux étable Id",
    "not-mapped": "(non cartographié)"
  },
  "birth-date": "Date de naissance",
  "breed": "Race",
  "cadaver": "Cadavre",
  "catching": "Rattrapage",
  "certification": "IKB",
  "chick-price": "Prix net par poussin, hors TVA",
  "chickens": "Poulets",
  "chicks-parents-age-in-weeks": "Âge des parents (en semaines)",
  "chicks-weight-in-grams": "Poids des poussins (en grammes)",
  "close-round": "Fermer le cycle",
  "concept": "Concept",
  "costs": "Coûts",
  "costs-specification": "Spécification des coûts",
  "couple": "Troupeau",
  "couple-number": "Nr",
  "couples": "Troupeaux",
  "customer-id": "Identifiant du client",
  "cycle": "Cycle",
  "cycle-navigation": {
    "balance": "Équilibre",
    "closure": "Fermeture",
    "day-old-chick": "Livraison",
    "departure": "Départ",
    "general": "Général"
  },
  "cycle-number": "Nr.",
  "enter-amounts": "Saisir le nombre",
  "n/a": "s/o",
  "cycle-overview": {
    "barn": "Étable",
    "consumption-empty": {
      "description": "Ajouter l'utilisation du flux pour voir les lignes d'équilibre ici.",
      "title": "Il n'y a pas de lignes d'équilibre."
    },
    "daily-performance-empty": {
      "description": "Ajouter une livraison pour rendre disponibles les observations hebdomadaires/journalières.",
      "title": "Entrée non disponible."
    },
    "cycle": "Cycle",
    "delete-cycle": "Supprimer",
    "edit-current-week": "Capturer les inscriptions hebdomadaires",
    "weekregistration-overview": "Aperçu de l'nscription hebdomadaires ",
    "detailedOverview": "Détaillé",
    "edit": "éditer",
    "edit-cycle": "Editer",
    "option-all-barn": "- toutes les étables -",
    "panel": {
      "add-day-old-chick": "ajouter l'arrivée",
      "add-departure": "Ajouter un départ",
      "amount": "Montant",
      "balance-overview": "Vue d'ensemble de l'équilibre",
      "balance-title": "Consommation d'aliments pour animaux",
      "birthdate": "Date de naissance",
      "consumption": "Consommation (kg)",
      "consumption-per-chick": "Consommation p.p.l.)",
      "date": "Date de livraison",
      "day-old-chick-overview": "Aperçu de l'arrivée",
      "day-old-chick-title": "Arrivée",
      "day-old-chick-total": "Arrivée totale",
      "departure-overview": "Aperçu des départs",
      "departure-title": "Départ",
      "departure-total": "Départ total",
      "departuredate": "Date de départ",
      "departureweight": "Poids au départ",
      "price": "Prix",
      "price-ex-vat-per-chick": "Prix par poussin (hors TVA)",
      "price-ex-vat": "Prix (hors TVA)",
      "product-title": "Nom de l'aliment",
      "product-type-mixedproduct": "Composé",
      "product-type-rawproduct": "Brut",
      "revenue": "Revenu",
      "slaughterweight": "Poids net payé",
      "type": "Type",
      "type-full": "Densité totale",
      "type-manual": "Guide",
      "type-partial": "Densité partielle",
      "type-platform": "Plateform",
      "type-start": "Plateform",
      "total-consumption": "Consommation totale",
      "daily-performance-title": "Enregistrements d'observations hebdomadaires et journalières",
      "edit-current-week": "Capturer les inscriptions hebdomadaires",
      "cycle-title": "Lot",
      "discount-title": "Réductions",
      "discount-overview": "Aperçu des réductions"
    },
    "placeholder": "- faire une sélection -",
    "start-new-cycle": "Démarrer un nouveau cycle",
    "weekregistration-download": "Télécharger le modèle",
    "weekregistration-upload": "Importation",
    "weekregistration-select-file": "Sélectionner un fichier...",
    "weekregistration-upload-csv-title": "Sélectionner un fichier CSV à importer",
    "upload-csv-message": "Les colonnes ne doivent pas être supprimées du modèle, même si elles sont vides. Les champs peuvent être laissés vides.",
    "upload-csv-notification": "Sélectionner un fichier CSV à importer",
    "weekregistration-select-interval-type": "Type d'intervalle",
    "download-weekly-report": "Rapport hebdomadaire",
    "cycle-start-in-future-warning-description": "La date de début de ce cycle se situe dans le futur. Pour cette raison, il n'est pas possible d'enregistrer des observations.",
    "cycle-start-in-future-warning-title": "Le lot n'a pas encore commencé"
  },
  "wdo-labels": {
    "mortality": "Mortalité",
    "feedIntake": "Consommation d'aliments",
    "waterIntake": "Consommation d'eau",
    "indoorTemperature": "Température intérieure (°C)",
    "outdoorTemperature": "Température extérieure (°C)",
    "indoorHumidity": "Humidité intérieure (%)",
    "outdoorHumidity": "Humidité extérieure (%)",
    "weight": "Poids (g)",
    "litterQuality": "Qualité de la litière",
    "litterQualities": {
      "Loose": "Qualité de la litière lâche (%)",
      "Caked": "Qualité de la litière croupie (%)",
      "Wet": "Qualité de la litière humide (%)"
    },
    "selection": "La sélection",
    "selectionSmall": "Sélection des petits pousins",
    "selectionLegProblems": "sélection de problème des pattes",
    "feedIntakeGramPerBird": "Consommation d'aliments (grammes par animal)",
    "feedIntakeKg": "Consommation d'aliments (Kg)",
    "waterIntakeMililiterPerBird": "Consommation d'eau (Ml par animal)",
    "waterIntakeL": "Consommation d'eau (L)",
    "kilogramSuffix": "Kg",
    "gramSuffix": "Gramme",
    "literSuffix": "L",
    "mililiterSuffix": "Ml",
    "ageInDays": "Âge en jours"
  },
  "wdo-settings": {
    "title": "Paramètres d'observation hebdomadaires et quotidiens",
    "disabled-message": "Ces paramètres ne peuvent pas être modifiés parce que des enregistrements hebdomadaires ont été effectués.",
    "startday-description": "Jour de départ par rapport à la date d'arrivée des troupeaux",
    "startday-label": "Réglage du jour de la semaine",
    "startday-placeholder": "- sélectionner un jour de départ -",
    "weekly-daily-description": "Vous pouvez déterminer ici les informations que vous souhaitez saisir quotidiennement ou hebdomadairement.",
    "open-settings": "Ouvrir les paramètres",
    "general-option": {
      "label": "Paramètres généraux",
      "per-day": "Par jour pour tous",
      "per-week": "Par semaine pour tous"
    },
    "setting-option": {
      "off": "Arrêt",
      "per-day": "Par jour",
      "per-week": "Par semaine"
    },
    "delete-confirm": {
      "title": "Êtes-vous sûr de vouloir modifier ces paramètres ?",
      "text": "Cette opération efface les données des indicateurs suivants lors de la sauvegarde ; "
    }
  },
  "wdo-registration": {
    "all-settings-are-off-title": "Tous les champs d'enregistrement ont été désactivés.",
    "all-settings-are-off-message": "Allez d'abord dans les paramètres des observations hebdomadaires et quotidiennes dans l'onglet Général de ce cycle et définissez vos paramètres à cet endroit.",
    "registration": "Enregistrement des observations hebdomadaires et journalières",
    "cycle-date": "Date d'arrivée",
    "cycle-end-date": "Date de fin de cycle",
    "select-week": "Semaine",
    "select-week-placeholder": "- sélectionner une semaine -",
    "select-barn": "Étable",
    "select-barn-placeholder": "- sélectionner une étable -",
    "validation-errors": {
      "total-must-be-100": "Le total de la qualité de la litière combinée doit être de 100 %.",
      "date-is-not-valid-title": "Dates incorrectes dans le fichier de téléchargement",
      "date-is-not-valid-description": "Le fichier de téléchargement contient des données dont le jour/la semaine est plus grand/petit que la date de fin/de début du lpot. Les données dont la date est correcte sont sauvegardées."
    },
    "next-day": "Le jour suivant"
  },
  "wdo-registration-overview": {
    "title": "Résumé des enregistrements d'observations",
    "weekly-registrations": "Inscriptions aux observations hebdomadaires",
    "daily-registrations": "Enregistrements d'observations quotidiennes",
    "columns": {
      "weeknr": "Semaine",
      "date": "Date"
    },
    "no-observations-found": {
      "title": "Aucune observation n'a été trouvée",
      "message": "Aucune observation hebdomadaire ou journalière n'a été saisie pour ce cycle."
    }
  },
  "chicks": "Poussins",
  "cycles": "Cycles",
  "dashboard": "Tableau ",
  "date": "Date",
  "date-of-arrival": "Date d'arrivée",
  "day-old-chicks": "Poussins d'un jour",
  "days": "Jours",
  "decontamination": "Décontamination",
  "delete": "Supprimer",
  "delete-item-balance": "Voulez-vous supprimer la ligne d'équilibre ?",
  "delete-item-barn-item": "Voulez-vous supprimer l'étable ?",
  "delete-item-day-old-chick": "Voulez-vous supprimer la livraison ?",
  "delete-item-departure": "Voulez-vous supprimer le départ ?",
  "delete-item-flock-cycle": "Voulez-vous supprimer le cycle du troupeau ?",
  "delivery": {
    "deliveries": "Livraisons",
    "delivery": "Livraison"
  },
  "delivery-item": {
    "amount": "Montant par étable",
    "delivery-date": "Date de livraison",
    "error-amount": "Ajouter le montant",
    "error-delivery-date": "Ajouter la date de livraison",
    "error-no-amount": "Ajouter le montant pour au moins une étable.",
    "error-price": "Indiquer le prix net",
    "error-product-title": "Ajouter la description du produit",
    "error-supplier-name": "Ajouter le nom du fournisseur",
    "error-units-delivered": "Ajouter les unités livrées",
    "error-units-delivered-not-enough": "Une partie de cette livraison a déjà été utilisée dans des bilans de cycles. Vous avez donc besoin d'un minimum de :",
    "error-vat": "Ajouter le pourcentage de TVA",
    "external-product-id": "Numéro de référence du produit",
    "manual-delivery": "Livraison manuel",
    "price": "Prix net (hors TVA)",
    "product-title": "Description du produit",
    "product-type-multiple": "Produit mixte",
    "supplier-name": "Nom du fournisseur",
    "units-delivered": "Unités livrées",
    "vat": "TVA",
    "price-per-100kg": "Prix net par 100 kg (hors TVA)",
    "error-price-per-100kg": "Indiquer le prix net par 100 kg",
    "barn": "Ètable",
    "invoice-date": "Date de facturation",
    "invoice-number": "Numéro de facture",
    "vat-percentage": "Pourcentage de TVA"
  },
  "delivery-overview": {
    "active": "Actif",
    "delivery": "Livraison",
    "delivery-lines": "Lignes de livraison",
    "display-in-cycle": "Affichage en cycle",
    "no-deactivation": {
      "description": "Il existe un cycle dans lequel cette livraison est utilisée.",
      "title": "Désactivation impossible"
    },
    "no-deliveries": {
      "description": "Les livraisons sont ajoutées automatiquement et sont affichées ici.",
      "title": "Pas de livraisons pour la période sélectionnée"
    },
    "remaining-of": "restant de",
    "remove-delivery-warning": {
      "text": "La livraison sera alors supprimée de votre liste. Les livraisons qui ont été utilisées dans les soldes ne peuvent pas être supprimées.",
      "title": "Êtes-vous sûr de vouloir supprimer cette livraison ?"
    },
    "table": {
      "deliveryDate": "Date de livraison",
      "deliveryId": "ID de livraison",
      "product": "Produit",
      "isActive": "Actif",
      "showInFinalSetup": "Afficher dans le bilan financier du lot",
      "invoiceDate": "Date de la facture",
      "invoiceNumber": "Numéro de facture"
    }
  },
  "departure": {
    "barn": "Étable",
    "empty-day-old-chicks-description": "Ajoutez une livraison et elle apparaîtra ici.",
    "empty-day-old-chicks-title": "Pas de livraisons",
    "empty-description": "Ajoutez un départ et il apparaîtra ici.",
    "empty-title": "Aucun départ"
  },
  "departure-date": "Date de départ",
  "departure-item": {
    "age": "L'âge",
    "amount-of-chicks": "Montant",
    "average-weight": "Poids moyen PAK",
    "barn": "Étable",
    "chicks": "poussins",
    "date": "Date",
    "error-amount-of-chicks-max": "Le nombre maximum de poussins est de :",
    "error-amount-of-chicks-min": "Ajouter au moins un poussin",
    "error-amount-of-chicks-required": "Saisir le nombre de poussins",
    "error-barn": "Sélectionner l'étable",
    "error-date": "Indiquez la date de départ. Cette date doit être postérieure à la date d'arrivée la plus proche, mais pas dans le futur.",
    "error-no-chicks-remaining": "Il n'y a plus de poussins pour le départ",
    "error-type": "Indiquer le type de départ",
    "footpad-lesion-score": "Score de lésion du coussinet \n",
    "footpad-lesion-none": "Score 0",
    "footpad-lesion-moderate": "Score 1",
    "footpad-lesion-severe": "Score 2",
    "footpad-lesion-validation": "La somme des pourcentages des points 0, 1 et 2 doit être exactement égale à 100 %.",
    "heel-dermatitis": "Dermatite du talon",
    "revenue": "Recettes totales (hors TVA)",
    "slaughter-results": "Résultats de l'abattage",
    "slaughter-weight": "Poids total à l'abattage",
    "rejection-at-slaughterhouse": "Rejet à l'abattoir",
    "rejection-during-transport": "Rejet pendant le transport",
    "slaughterhouse": "Abattoir",
    "type": "Type",
    "type-full": "Chargement totale",
    "type-partial": "Desserrage",
    "weight": "Poids au départ non ajeun",
    "weight-validation": "Le poids total payé de l'abattage ne peut pas être supérieur au poids de départ.",
    "diverseCosts": "Diversité des coûts",
    "revenueSubTotal": "Recettes (hors TVA)"
  },
  "departure-title": "Départ",
  "departure-type-full": "Complet",
  "departure-type-partial": "Partiel",
  "download-pdf": "Télécharger le PDF",
  "edit": "changer\n",
  "electricity": "L'électricité",
  "error-amount-of-chickens": "Indiquer le montant des poulets",
  "error-amount-of-chicks": "Indiquer la quantité de poussins d'un jour",
  "error-amount-of-chicks-too-big": "La quantité de poussins d'un jour est trop élevée",
  "error-arrival-date": "Saisir la date d'arrivée",
  "error-barn-selected": "Sélectionner l'étable",
  "error-breed": "Sélectionner la race",
  "error-chick-birth-date": "Saisir la date de naissance",
  "error-chick-price": "Saisir le prix du poussin d'un jour",
  "error-concept": "Sélectionner le concept",
  "error-cycle-number": "Saisir un numéro de cycle unique",
  "error-hatchery": "Sélectionner le couvoir",
  "error-start-date": "Saisir la date de mise en place",
  "error-surface-area": "Entrer la surface de l'étable",
  "error-total-costs": "Saisir les coûts totaux",
  "error-total-price": "Saisir le montant",
  "feed": "Alimentation",
  "flocks": "Troupeaux",
  "general": "Général",
  "grams": "grammes",
  "hatchery": "Couvoir",
  "healthcare": "Soins de santé",
  "heating": "Chauffage",
  "litter": "Litière",
  "management": "Gestion",
  "manure": "Fumier",
  "no-barns-description": "Ajoute un étable et ceci va être montré ici",
  "no-barns-title": "Pas d'étables ajoutés",
  "no-cycle-selected-description": "Selectez un lot pour voire l'information",
  "no-cycle-selected-title": "Un cycle n'a pas été sélectionné",
  "no-cycles-description": "Ajoutez un lot et ceci va être montré",
  "no-cycles-title": "Pas de cycles",
  "no-day-old-chicks-description": "Ajoutez livraison de poussins et ceci va être montré ici",
  "no-day-old-chicks-title": "Pas de livraison des poussins d'un jour ",
  "no-departures-description": "Ajoutez le départ et ceci va être montré ici",
  "no-departures-title": "Aucun départ",
  "none": "Aucun",
  "nr": "Nr.",
  "number-of-day-old-chicks": "nombre de poussins d'un jour",
  "other": "Autres",
  "print": "Imprimer",
  "remove-cycle": "Retirer le cycle",
  "report-navigation": {
    "barn-report": "Bilan de l'étable"
  },
  "report-overview": {
    "barn": "étable",
    "barn-report": "bilan d'étable",
    "barn-report-loading": "Bilan de l'étable est généré...",
    "cycle": "Cycle",
    "reports": "Rapports",
    "cycle-closed": "(Lot terminé)"
  },
  "save-as-concept": "conserver par  concept",
  "settings": "Paramètres",
  "settings-navigation": {
    "barns": "Étables",
    "observationsetting": "Observations",
    "rvssetting": "Fiches avec normes",
    "farmresultsetting": "Résultat de l'exploitation",
    "performance": "Performances",
    "finalsetupsetting": "Bilan financier du lot",
    "discountsetting": "Réductions",
    "sustainabilitysetting": "Durabilité"
  },
  "observations-setting": {
    "description": "Souhaitez-vous suivre les performances du cycle sur une base hebdomadaire et quotidienne ?",
    "switch": "Activez les observations hebdomadaires/quotidiennes"
  },
  "column-setting": {
    "title": "Paramètres des colonnes",
    "description": "Colonnes"
  },
  "rvs-setting": {
    "title": "Paramètres des fiches avec normes",
    "temperatureInside-option": {
      "label": "Température",
      "Celcius": "Celcius",
      "Fahrenheit": "Fahrenheit",
      "short": {
        "Celcius": "(°C)",
        "Fahrenheit": "(F)"
      }
    },
    "feedIntake-option": {
      "label": "Alimentation",
      "Gram": "Gramme",
      "Kilogram": "Kilogramme",
      "short": {
        "Gram": "(g)",
        "Kilogram": "(kg)"
      }
    },
    "waterIntake-option": {
      "label": "L'eau",
      "ML": "Millilitre",
      "DL": "Décilitre",
      "L": "Litre",
      "short": {
        "ML": "(ml)",
        "DL": "(dl)",
        "L": "(l)"
      }
    },
    "weight-option": {
      "label": "Poids",
      "Gram": "Gramme",
      "Kilogram": "Kilogramme",
      "short": {
        "Gram": "(g)",
        "Kilogram": "(kg)"
      }
    },
    "dayoffset": {
      "title": "Début de réglage du jour start",
      "label": "Jour de début"
    }
  },
  "specify-costs": "Préciser les coûts",
  "start-date": "Date de mise en place",
  "title": "PoultryNEXT",
  "title_Agrifirm": "PoultryNEXT",
  "title_Agravis": "Avidata broiler",
  "total-costs": "Coûts totaux",
  "total-price": "Montant, hors TVA",
  "unspecified-costs": "Coûts non spécifiés",
  "water": "L'eau",
  "water-additives": "Additifs pour l'eau",
  "weeks": "semaines",
  "search": "Rechercher",
  "dateFrom": "De",
  "dateTo": "Pour",
  "days-of-week": {
    "Monday": "lundi",
    "Tuesday": "mardi",
    "Wednesday": "mercredi",
    "Thursday": "jeudi",
    "Friday": "vendredi",
    "Saturday": "samedi",
    "Sunday": "dimanche"
  },
  "unitOfMeasure": {
    "g/day": "g/jour",
    "€/m²/day": "€/m²/jour",
    "$/m²/day": "$/m²/jour",
    "£/m²/day": "£/m²/jour",
    "zł/m²/day": "zł/m²/jour",
    "Ft/m²/day": "Ft/m²/jour"
  },
  "feed-advice": {
    "overview": {
      "title": "Aperçu des conseils d'alimentation",
      "empty": {
        "title": "Les conseils d'alimentation ne sont pas disponibles",
        "description": "Il n'y a pas de conseils d'alimentation disponibles pour le moment."
      },
      "table-header": {
        "name": "Nom",
        "created": "Crée",
        "updated": "Mise à jour",
        "updatedAdvisorName": "Mise à jour par",
        "isActive": "Actif"
      },
      "buttons": {
        "add": "Créer un avis d'alimentation ",
        "edit": "Ajuster",
        "delete": "Supprimer"
      }
    },
    "create-from-reference": {
      "title": "Faire un avis d'alimentation",
      "scratch-title": "Commencer un nouveau avis d'alimentation",
      "scratch-option-title": "Commencer un avis d'alimentation",
      "scratch-button": " Commencer avec un avis vide",
      "scratch-option-subtitle": "Ceci est un avis vide",
      "reference-schemes-title": "Choissisez un avis d'alimentation standard comme base",
      "reference-schemes-button": "commençez avec",
      "product": "Produit",
      "products": "Produits",
      "additive": "Additif",
      "additives": "Additifs"
    },
    "dialog": {
      "deleteConfirm": "Êtes-vous sûr de vouloir supprimer cet avis ?",
      "deleteConfirmWhenInUse": "Cet avis d'alimentation est lié à un lot, êtes-vous sûr de vouloir supprimer cet avis d'alimentation ?"
    },
    "create": {
      "print": "Imprimer",
      "title": "Avis d'alimentation",
      "name": "Nom de l'avis d'alimentation",
      "error-name": "Un nom pour l'avis d'alimentation est obligatoire.",
      "description": "Description",
      "description-placeholder": "Description d'avis d'alimentation",
      "product-placeholder": "- sélectionner un produit -",
      "add-product": "Ajouter un produit",
      "table-header": {
        "productName": "Produit",
        "chickenWeightInGrams": "Poids du poussin (g)",
        "ageFrom": "Âge à partir de (jours)",
        "ageTo": "Âge jusqu'à (jours)",
        "totalFeed": "Consommation d'aliments (g)",
        "coreFeed": "Noyau (g)",
        "wheatFeed": "Blé (g)",
        "comment": "Commentaires",
        "age": "Âge (jours)",
        "coreFeedTons": "Noyau (tonnes)",
        "wheatFeedTons": "Blé (tonnes)",
        "dosage": "Dosage (kg/tonne)",
        "applicationMoment": "l'âge de l'application"
      },
      "created": "Crée",
      "updated": "Mise à jour",
      "number-of-day-old-chicks": "Nombre de poussins d'un jour",
      "validation-error": {
        "title": "Erreur(s) de validation",
        "feedadvice-name": "Le nom de l'avis alimentaire est obligatoire",
        "age-from": "L'âge de est obligatoire",
        "chicken-weight": "Le poids du poulet est obligatoire",
        "product": "Le produit est obligatoire",
        "total-feed": "L'alimentation totale est obligatoire",
        "age-to": "L'âge jusqu'à est obligatoire (sauf à la dernière ligne)",
        "age-min-max": "L'âge de départ doit être inférieur à l'âge d'arrivée."
      },
      "products": "Conseil avis de base",
      "additives": "Additifs",
      "show-additives": "Afficher les additifs",
      "add-additive": "Ajouter un complément"
    },
    "print": {
      "farmcompany": "Entreprise",
      "customernr": "Numéro de client",
      "contactperson": "Personne de contact",
      "location": "Location",
      "customerservice": "Service clientèle",
      "table-header": {
        "productName": "Produit",
        "chickenWeightInGrams": "Poids du poussin",
        "age": "L'âge",
        "totalFeed": "Consommation d'aliments",
        "coreFeed": "Noyau",
        "wheatFeed": "Blé",
        "comment": "Commentaires",
        "gramPerChick": "Gramme/poussin",
        "orderQuantity": "Quantité commandée (tonne)",
        "units_gram": "(g)",
        "units_days": "(jours)",
        "dosage": "Dosage",
        "units_kgton": "kg/tonne",
        "applicationMoment": "Moment de l'application"
      }
    }
  },
  "standard-reference-value-sheet": {
    "overview": {
      "title": "Aperçu des fiches de normes standard "
    },
    "create": {
      "title": "Fiche des normes standard"
    }
  },
  "reference-value-sheet": {
    "overview": {
      "title": "Vue d'ensemble des fiches de normes",
      "empty": {
        "title": "Dates des fiche de normes pas disponibles",
        "description": "Aucune fiche de normes est disponible pour le moment."
      },
      "table-header": {
        "name": "Nom ",
        "created": "crée  ",
        "updated": "Mis à jour   ",
        "updatedAdvisorName": "Mise à jour par",
        "isActive": "Actif"
      },
      "buttons": {
        "add": "Ajouter fiche des normes",
        "edit": "Adapter",
        "delete": "Supprimer",
        "copy-as-new": "Copier comme nouveau",
        "copy-to-other-country": "Copie vers un autre pays"
      },
      "country": "Pays"
    },
    "dialog": {
      "deleteConfirm": "Êtes-vous sûre que vous voulez suprimer l'afiche des normes",
      "deleteConfirmWhenInUse": "Cette fiche de normes est liée à un lot, êtes-vous sûr de vouloir supprimer cette fiche de normes ?"
    },
    "create-from-standard": {
      "title": "Créer une fiche des normes",
      "scratch-title": "Commencer avec une nouvelle fiche de normes",
      "scratch-option-title": "Commencez une fiche de normes",
      "scratch-button": "Commencez une fiche de normes vide",
      "scratch-option-subtitle": "Il s'agit d'une fiche de normes vide",
      "reference-value-sheet-title": "Choisir une fiche de normes standard comme base",
      "reference-value-sheet-button": "Commencez par "
    },
    "create": {
      "print": "Imprimer",
      "title": "Fiche de normes",
      "name": "Nom de la fiche de normes",
      "error-name": "Le nom de la fiche de normes est obligatoire",
      "add-one-day-values-row": "Ajouter un jour",
      "number-of-days": "Jours",
      "add-multiple-day-values-rows": "Ajouter des jours",
      "description": "Description",
      "description-placeholder": "Description de la fiche de normes",
      "no-day-values-title": "La fiche de normes est encore vide",
      "no-day-values-description": "Pour commencer, ajoutez des jours à la fiche de normes ci-dessous.",
      "table-header": {
        "day": "Jour",
        "temperatureInside": "Température à l'intérieur ",
        "relativeHumidity": "Humidité relative (%)",
        "feedIntake": "Consommation d'aliments ",
        "feedIntakePerChickPerDay": "Consommation d'aliments ",
        "feedIntakeTotal": "Consommation d'aliments Cum ",
        "feedIntakePerChickTotal": "Consommation d'aliments Cum ",
        "waterIntake": "L'eau ",
        "weight": "Poids ",
        "mortality": "Mortalité",
        "feedConversion": "Conversion des aliments Cum",
        "waterToFeedRatio": "Eau:alimentation Cum"
      },
      "created": "Crée",
      "updated": "Mise à jour",
      "validation-error": {
        "title": "Erreur(s) de validation",
        "refvalsheet-name": "Le nom de la fiche de normes est obligatoire."
      }
    },
    "print": {
      "farmcompany": "Entreprise agricole",
      "customernr": "Numéro de client",
      "contactperson": "Personne de contact",
      "location": "Location"
    },
    "select-country": {
      "title": "Sélectionner le pays",
      "description": "Sélectionnez le pays vers lequel vous souhaitez le copier",
      "label": "Pays"
    }
  },
  "reference-scheme": {
    "overview": {
      "title": "Aperçu d'avis d'alimentation standard",
      "empty": {
        "title": "Dates d'avis alimentation sont indisponibles",
        "description": "Dates d'avis alimentation sont indisponibles a ce moment"
      },
      "table-header": {
        "name": "Nom",
        "created": "Crée",
        "updated": "Mise à jour",
        "updatedAdvisorName": "Mise à jour par",
        "isActive": "Actif"
      },
      "buttons": {
        "add": "Créer un avis d'alimentation standard",
        "edit": "Ajuster",
        "delete": "Supprimer"
      },
      "country": "Pays"
    },
    "dialog": {
      "deleteConfirm": "Êtes-vous sûre de vouloir supprimer l'avis d'alimentation ?"
    },
    "create": {
      "title": "Avis d'alimentation standard",
      "name": "Nom de l'avis d'alimentation standard",
      "error-name": "Un nom pour l'avis d'alimentation standard est obligatoire",
      "description": "Description",
      "description-placeholder": "Description de l'avis d'alimention standard",
      "product-placeholder": "- sélectionner un produit -",
      "add-product": "Ajouter un produit",
      "table-header": {
        "productName": "Produit",
        "chickenWeightInGrams": "Poids du poussin (g)",
        "ageFrom": "Âge à partir de (jours)",
        "ageTo": "Âge jusqu'à (jours)",
        "totalFeed": "Consommation d'aliments (g)",
        "coreFeed": "Noyau (g)",
        "wheatFeed": "Blé (g)",
        "comment": "Commentaire"
      },
      "created": "Crée",
      "updated": "Mise à jour"
    }
  },
  "product-title": "Produits",
  "product-save": "Sauvegarder le produit",
  "product-saved": "Produit sauvegardé !",
  "product-overview": {
    "title": "Aperçu des produits",
    "overview": {
      "productName": "Nom",
      "productCode": "Code de produit",
      "phase": "Phases",
      "isActive": "Actif",
      "productType-Feed": "Alimentation",
      "productType-Additive": "Additif",
      "productType": "Type de produit"
    },
    "no-products": {
      "title": "Aucun produit trouvé",
      "description": "En cliquant sur Ajouter, un produit peut être créé."
    },
    "delete-confirmation-title": "Supprimer un produit",
    "delete-confirmation-message": "Êtes-vous sûre de vouloir supprimer ce produit ?",
    "delete-error-message": "Nous n'avons pas pu supprimer le produit. Assurez-vous que le produit n'est pas utilisé dans un shéma de référence.",
    "delete-error-in-use-message": "Nous n'avons pas pu supprimer le produit, car il est utilisé dans un ou plusieurs avis d'alimentations",
    "country": "Pays",
    "delete-confirmation-message-when-in-use": "Ce produit est utilisé dans un ou plusieurs avis d'alimentation, êtes-vous sûr de vouloir supprimer ce produit ?"
  },
  "create-product": {
    "title-create": "Ajouter un produit",
    "title-edit": "Modifier le produit :",
    "product-name": "Nom du produit",
    "phases-label": "Phases des alimentations",
    "product-code": "Code de produit",
    "error-product-name": "Veuillez indiquer le nom du produit.",
    "error-product-code": "Veuillez indiquer le code du produit.",
    "error-code-name-already-in-use": "Veuillez utiliser une combinaison unique de nom et de code",
    "product-type": {
      "label": "Type de produit",
      "Feed": "Alimentation",
      "Additive": "Additif"
    },
    "error-product-type": "Le type de produit est obligatoire"
  },
  "countries": {
    "BE": "Belgique",
    "DE": "Allemagne",
    "HU": "Hongrie",
    "NL": "Pays-Bas",
    "PL": "Pologne",
    "JO": "Jordanie",
    "NG": "Nigéria",
    "JM": "Jamaïque",
    "TZ": "Tanzanie",
    "DA": "Allemagne-Agravis"
  },
  "save": "Sauvegarder",
  "report-title": "Vue d'ensemble des poulaillers",
  "report-name": "Rapport du lot",
  "report-headers": {
    "general": "Général",
    "day-old-chicks": "Mise en place des poussins d'un jour",
    "total": "Total",
    "departures": "Départ des poussins",
    "balance": "Vue d'ensemble des aliments",
    "key-figures": "Chiffres clés",
    "technical": "Technique",
    "financial": "Financier"
  },
  "report-columns": {
    "customer": "Client",
    "location": "Location",
    "barn": "Étable",
    "breed": "Race",
    "concept": "Concept",
    "start-date": "Date de mise en place",
    "date": "Date",
    "age": "Âge [jours]",
    "amount": "Nombre",
    "price": "Prix (hors TVA)",
    "discount": "Remise (hors TVA)",
    "delivered": "Livré [kg]",
    "weight": "Poids [g]",
    "paid": "Payé [kg]",
    "rejected": "Rejeté [%]",
    "feed-code": "Code d'alimentation",
    "feed-name": "Nom de l'aliment",
    "consumption": "Consommation [kg]",
    "consumption-per-day-old-chick": "Consommation par poussin d'un jour [g]",
    "day-old-chicks": "Nombre de poussins d'un jour (m²)",
    "drop-out-total": "Mortalité total (%)",
    "avg-age": "Âge moyen (jours)",
    "avg-weight": "Poids moyen (g)",
    "deliveredkg-per-m2": "Livré kg par m²",
    "growth": "Croissance (g/j)",
    "feed-conversion": "Conversion alimentaire",
    "feed-conversion-1500": "Conversion alimentaire 1500 ",
    "replacement": "Pourcentage de blé",
    "avg-rejected": "Déclassés retirés (%)",
    "production-number": "Ciffre de production",
    "price-per-delivered-chick": "Prix par poussin livré (ct)",
    "feed-price-per-100": "Prix des aliments par 100 kg ",
    "feed-price-per-delivered-kg": "Coûts des aliments par kg livré (ct)",
    "yield-per-kg": "Revenu par kg",
    "feed-profit": "Marge poussin aliment",
    "feed-profit-per-day-old-chick": "Marge poussin aliment par poussin mise en place",
    "feed-profit-per-m2-per-day": "Marge poussin aliment par m2 et par jour",
    "cycle-nr": "Cycle nr",
    "barns": "Étables",
    "netto-profit-incl-other-costs": "Bénéfice net",
    "discountLabel-ledenvoordeel": "Avantages pour les membres",
    "discountLabel-ledenkorting": "Réduction pour les membres",
    "discountLabel-integratiepremie": "Prime d'intégration",
    "discountLabel-nieuwbouwpremie": "Prime à la nouvelle construction",
    "discountLabel-ncw": "Distribution de la valeur actuelle nette",
    "total-incl-discount": "Total (y compris les remises)",
    "discountLabel-korting": "Remise",
    "discountLabel-overig": "Autres",
    "discountLabel-nabetaling": "Paiement rétroactif",
    "discountLabel-correctievoerprijs": "Correction prix d'aliment",
    "discountLabel-vergoedingvolgensafspraak": "Rémunération selon l'accord",
    "feed-profit-per-m2": "Revenu alimentaire par m²"
  },
  "total": "Total",
  "days-short": "Jours",
  "parent-stock-identifier": "ID du stock parent",
  "import": "Importation",
  "csv-import": {
    "delivery-success": "Livraisons importées avec succès.",
    "departure-success": "Départs importés avec succès.",
    "errors": {
      "amount-exceeds-remaining": "Ligne ${rowNumber} : le nombre dépasse le nombre de poussins restants pour le bâtiment '${barn}'. Le nombre maximum autorisé est ${maxAmount}.",
      "barn-not-found": "Ligne ${rowNumber} : le bâtiment '${value}' est introuvable dans le cycle sélectionné.",
      "configured-slaughterhouses-could-not-be-loaded": "Les abattoirs configurés n'ont pas pu être chargés.",
      "cycle-could-not-be-loaded": "Le cycle '${cycleId}' n'a pas pu être chargé.",
      "cycle-invalid": "Les départs CSV ne sont pas valides pour le cycle sélectionné.",
      "cycle-not-found": "Le cycle '${cycleId}' est introuvable pour le client/site actuel.",
      "date-before-first-arrival": "Ligne ${rowNumber} : la date doit être égale ou postérieure à la première date d'arrivée.",
      "date-in-future": "Ligne ${rowNumber} : la date ne peut pas être dans le futur.",
      "duplicate-column": "Le CSV contient la colonne en double '${column}'.",
      "file-empty": "Le fichier CSV est vide.",
      "file-required": "Le fichier CSV est obligatoire.",
      "file-too-large": "Le fichier CSV est trop volumineux. La taille maximale autorisée est de ${maxSizeKb} Ko.",
      "invalid-date": "Ligne ${rowNumber} : ${field} est obligatoire et doit être une date valide.",
      "invalid-number": "Ligne ${rowNumber} : ${field} doit être un nombre valide.",
      "missing-required-columns": "Il manque au CSV une ou plusieurs colonnes obligatoires : ${columns}.",
      "no-data-rows": "Le CSV doit contenir au moins une ligne de données.",
      "required-field": "Ligne ${rowNumber} : ${field} est obligatoire.",
      "required-positive-whole-number": "Ligne ${rowNumber} : ${field} est obligatoire et doit être un nombre entier positif.",
      "required-valid-number": "Ligne ${rowNumber} : ${field} est obligatoire et doit être un nombre valide.",
      "skip-import-invalid": "Ligne ${rowNumber} : Ignorer l'importation doit être vide ou contenir l'une des valeurs suivantes : yes, no, true, false, 1, 0, x.",
      "slaughterhouse-not-found": "Ligne ${rowNumber} : l'abattoir '${value}' est introuvable.",
      "too-many-rows": "Le CSV contient trop de lignes. Le nombre maximum autorisé est ${maxRows}.",
      "total-slaughterweight-higher-than-departure-weight": "Ligne ${rowNumber} : le poids total d'abattage ne peut pas être supérieur au poids de départ.",
      "type-invalid": "Ligne ${rowNumber} : le type est obligatoire et doit être Complet ou Partiel.",
      "unterminated-quote": "Le CSV contient une valeur avec un guillemet ouvrant sans guillemet fermant.",
      "unknown": "L'importation CSV a échoué.",
      "unsupported-file-type": "Seuls les fichiers CSV sont pris en charge."
    },
    "download-template": "Télécharger le modèle",
    "invalid-file": "Sélectionnez un fichier CSV valide.",
    "upload": "Importer le CSV"
  },
  "slaughter-report": "Rapport d'abattage",
  "link-slaughter-results-title": "Liez les résultats de l'abattage",
  "link-slaughter-results-description": "Sélectionnez une étable par rapport d'abattage. Pour chaque rapport d'abattage, une ligne de départ sera crée.",
  "slaughter-date": "Date d'abattage",
  "number-of-chickens": "Nombre de poulets",
  "departure-weight-kg": "Poids au départ (kg)",
  "show-financial-data": "Afficher les données financières",
  "financial-results": "Résultats financiers",
  "link-to-barn": "Liez vers l'étable",
  "imported-slaughter-report-label": "Rapport sur les abattages importés",
  "slaughter-weight-kg": "Poids d'abattage (kg)",
  "veterinary": "Vétérinaire",
  "employment": "Employé",
  "otherRevenue": "Autres recettes",
  "otherCosts": "Autres coûts",
  "discount-title": "Réductions",
  "discount-label": "Label de réduction",
  "discount-applicabilityType": "S'applique à",
  "discount-amount": "Montant, hors TVA",
  "discount-item": {
    "applicabilityType-arrivalcost": "Frais d'arrivée",
    "applicabilityType-feedcost": "Coût de l'alimentation",
    "applicabilityType-departurerevenue": "Recettes de départ",
    "add-discount": "Ajouter une réduction",
    "labelType-ledenvoordeel": "Avantages pour les membres",
    "labelType-ledenkorting": "Réduction pour les membres",
    "labelType-integratiepremie": "Prime d'intégration",
    "labelType-nieuwbouwpremie": "Prime à la nouvelle construction",
    "labelType-ncw": "Distribution de la valeur actuelle nette",
    "labelType-korting": "Remise",
    "labelType-overig": "Autres",
    "labelType-nabetaling": "Paiement rétroactif",
    "labelType-correctievoerprijs": "Correction prix d' aliment",
    "labelType-vergoedingvolgensafspraak": "Rémunération selon l'accord"
  },
  "discount": {
    "no-discounts-title": "Il n'y a pas encore de réductions.",
    "no-discounts-description": "Ajoutez une réduction et elle sera affichée ici."
  },
  "delete-item-discount": "Voulez-vous supprimer la réduction ?",
  "farm-result": {
    "table-header": {
      "sensorActuator": "Id capteur/actionneur",
      "barn": "Étable",
      "sensorActuatorName": "Nom du capteur/de l'actionneur",
      "farmResultLocationId": "Localisation Id"
    },
    "select-barn-placeholder": "- sélectionner une étable -"
  },
  "discountLabel-korting": "Remise",
  "discountLabel-overig": "Autres",
  "discountLabel-nabetaling": "Paiement rétroactif",
  "discountLabel-correctievoerprijs": "Correction prix d'aliments",
  "discountLabel-vergoedingvolgensafspraak": "Compensation par accord",
  "delete-item-day-old-chick-used-in-balance": "Cette livraison est actuellement utilisée pour le solde. Si vous décidez de supprimer cette livraison, le solde doit être recalculé. Voulez-vous supprimer la livraison ?",
  "edit-day-old-chick_barn-used-in-balance": "Vous modifiez une étable qui est utilisée sur la balance. Si vous enregistrez cette modification, le solde doit être recalculé. Voulez-vous continuer ?",
  "cycle-description": "Description",
  "confirm": "Confirmer",
  "interval-type-Day": "Jour",
  "interval-type-Week": "Semaine",
  "unitOfMeasure-setting": {
    "title": "Unité de mesure",
    "warning": "La modification des paramètres de l'unité de mesure peut entraîner de légères différences de valeur dues à l'arrondi mathématique.",
    "waterIntakeUnit": "Unité d'arrivée d'eau",
    "CumulativeLiter": "Litre totale consomer",
    "MililiterPerBird": "Ml par animal",
    "feedIntakeUnit": "Unité d'alimentation ",
    "CumulativeKilogram": "Kg Totale ",
    "GramPerBird": "Gramme par animal"
  },
  "error-amount-of-chicks-minimum": "Le nombre minimum de poussins est de :",
  "animal-group": {
    "animalGroupTitle": "Groupe des animaux",
    "switchDay": "Jour de changement",
    "addSwitchDay": "Ajouter un jour de transition",
    "phaseFrom": "Phase de",
    "phaseTo": "Phase vers",
    "date": "Date",
    "medication": "Médicaments",
    "treatmentDateStart": "Début du traitement",
    "treatmentDateEnd": "Fin du traitement",
    "addMedication": "Ajouter un médicament",
    "diagnose": "Diagnostiquer",
    "quantity": "Quantité",
    "unit": "Unité",
    "quantityUnitDescriptions": {
      "kilogram": "Kilogrammes",
      "gramsPerLitre": "Grammes par litre",
      "percentage": "Pourcentage",
      "gram": "Grammes",
      "noUnit": "Aucune unité",
      "gramsPerKilogram": "Grammes par kilogramme",
      "milligram": "Milligrammes",
      "milligramsPerKilogram": "Milligrammes par kilogramme"
    },
    "vaccination": "Vaccination",
    "addVaccination": "Ajouter la vaccination",
    "vaccine": "Vaccin",
    "poultryDisease": "Maladie de la volaille",
    "vaccinationMethod": "Méthode de vaccination",
    "validationDialogTitle": "Informations nécessaire",
    "validationDialogMessage": "Veuillez ajouter les informations nécessaires dans les tableaux",
    "veterinarianTitle": "Vétérinaire"
  },
  "final-setup-setting": {
    "switch": "Bilan financier du lot",
    "chick-delivery-switch": "Livraisons des poussins",
    "feed-delivery-switch": "Livraisons d'aliments",
    "departure-switch": "Départ",
    "discount-switch": "Réductions",
    "title": "Bilan financier du lot",
    "default-settings-title": "Paramètres standards",
    "masterdata": {
      "title": "Données de référence",
      "notes": "Notes",
      "payer": "Payeur",
      "payer-email": "Adresse mail du payeur",
      "representative-agrifirm": "Représentant commercial <Tenant>",
      "separate-stable": "Étable séparée",
      "integration-premium": "Prime d'intégration",
      "discount-value": "valeur de la ristourne",
      "agrifirm-member": "Membre de <Tenant>"
    }
  },
  "invoice-date": "Date de la facturation",
  "invoice-number": "Numéro de facture",
  "vat-percentage": "Pourcentage de TVA",
  "vat": "TVA (%)",
  "amount-including-vat": "Montant TTC (€)",
  "final-setup": {
    "chick-deliveries": "Livraison des poussins",
    "empty-chick-deliveries-title": "Pas de livraison de poussins",
    "empty-chick-deliveries-description": "Pas de livraison de poussins",
    "day-old-chick": "Poussins d'un jour",
    "feed-deliveries": "Livraisons d'aliments ",
    "empty-feed-deliveries-title": "Pas de livraison d'aliments ",
    "empty-feed-deliveries-description": "Pas de livraison d'aliments ",
    "empty-departures-description": "Aucun départ",
    "departures": "Départ",
    "empty-departures-title": "Aucun départ",
    "discounts": "Réductions",
    "empty-discounts-title": "Aucune réduction",
    "empty-discounts-description": "Aucune réduction",
    "print-footer": "Tous les contrats conclus et les produits et/ou services fournis par nous sont exclusivement soumis aux conditions générales de livraison d'Agrifirm NWE BV. Celles-ci vous seront envoyées gratuitement à la première demande et peuvent également être consultées et sauvegardées à l'adresse suivante : https://www .agrifirm.nl/globalassets/agrifirm-group/agrifirm-nl/leveringsvoorwaarden/general-terms--nl.pdf.",
    "print-footer-agravis": "Tous les contrats conclus et les produits et/ou services fournis par nous sont exclusivement soumis aux conditions générales de livraison d'Agravis. Celles-ci vous seront envoyées gratuitement à la première demande.",
    "print-description": "Description",
    "print-message-line-1": "Cher monsieur, chère madame,",
    "print-message-line-2": "Nous vous enverrons un aperçu des factures du dernier lot.",
    "print-end-line-1": "L'aperçu ci-dessus doit correspondre à votre administration.",
    "print-end-line-2": "Je vous prie d'agréer, Madame, Monsieur, l'expression de mes salutations distinguées,",
    "print-company-name": "Agrifirm NWE BV",
    "print-company-name-agravis": "Agravis",
    "print-company-email": "E-mail: kengetallenadministratie@agrifirm.com",
    "print-company-email-agravis": "E-mail: info@agravis.nl",
    "print-company-phone": "Téléphone: 088 - 488 2976",
    "print-company-phone-agravis": "",
    "print-to-receive": "Pour recevoir par vous",
    "print-total-feed": "Alimentation totale, voir annexe pour les spécifications",
    "print-invoice-number": "Numéro de facture",
    "print-amount-excluding-vat": "Montant hors TVA",
    "print-vat-amount": "TVA",
    "print-amount-including-vat": "Montant TTC",
    "print-product": "Produit",
    "print-net-weight": "Net (kg)",
    "include-in-calculations-label": "Inclure dans les calculs",
    "print-to-pay": "A payer par vous",
    "print-payment-terms": "Nous vous prions de bien vouloir verser le montant susmentionné dans un délai de 14 jours, en indiquant votre numéro de client, sur le compte bancaire NL.86.RABO.010.10.50.003.",
    "print-subtotal": "Sous-total",
    "feed-delivery-end-date": "Date de fin du lot de configuration finale",
    "additional-invoices": "Factures supplémentaires (Exlan, etc.)",
    "empty-additional-invoices-title": "Pas de factures supplémentaires",
    "empty-additional-invoices-description": "Pas de factures supplémentaires",
    "additional-invoices-add": "Ajouter ",
    "additional-invoices-delete-confirm-title": "Supprimer une facture ",
    "additional-invoices-delete-confirm-description": "Êtes-vous sûr de vouloir supprimer cette facture ?",
    "fixed-price": "Accord à prix fixe",
    "fixed-price-per-100": "Prix par 100 kg",
    "fixed-price-correction": "Correction de prix sur la base d'un prix fixe",
    "price-agreement": "accord de prix",
    "per-100-kg": "/ 100 kg hors TVA."
  },
  "amount-excluding-vat": "Montant hors TVA (€)",
  "discount-description": "Description",
  "discount-showInFinalSetup": "Afficher dans le Bilan financier du lot",
  "label": "Étiquette",
  "link-slaughter-invoices-description": "Sélectionnez les factures qui doivent être liées au lot. Pour chaque facture, une ligne sera créée dans la configuration finale.",
  "link-slaughter-invoices-title": "Lier les factures d'abattage",
  "slaughter-invoice": "Facture d'abattage",
  "vaccination-price": "Prix de la vaccination par poussin, hors TVA",
  "discount-price": "Remise par poussin, hors TVA",
  "diverse-price": "Coût diversifié par poussin, hors TVA",
  "total-price-including-vat": "Montant, TVA incluse",
  "total-calculated-amount": "Montant total, hors TVA",
  "total-calculated-amount-including-vat": "Montant total, TVA incluse",
  "arrival-notification-cycle-overview": "Le prix net et la réduction nette sont utiliser pour faire le bilan technique par lot et le bilan financier par lot",
  "arrival-notification-final-setup": "Le prix net par vaccination et les éléments divers par poussin sont inclus dans l'aperçu financier, où l'on trouve le total.",
  "edit-day-old-chick": "Modifier la livraison",
  "edit-departure": "Modifier le départ",
  "of-delivery": "de la livraison",
  "delivery-date": "Date de livraison",
  "delivery-number": "ID de livraison",
  "base-quantity": "Quantité (kg)",
  "discount-setting": {
    "title": "Réductions",
    "memberDiscountNL": "Réduction pour les membres (€)",
    "memberBenefitNL": "Prestations aux membres (%)",
    "memberBenefitAbroad": "Prestations des membres à l'étranger (%)",
    "warning-title": "Attention !",
    "warning-message": "Ces valeurs sont utilisées pour tous les clients et tous les sites. Ne les modifiez pas."
  },
  "sustainability": {
    "calculations": {
      "source": "Source",
      "value": "Valeur",
      "unit": "Unité",
      "description": "Consultez les calculs précédents ou calculez un autre cycle.",
      "new": "Nouveau calcul",
      "result": "Résultat enregistré",
      "history": "Calculs précédents",
      "last-updated": "Dernière mise à jour",
      "history-description": "Sélectionnez un calcul pour voir son résultat.",
      "calculation": "Calcul",
      "view-result": "Voir le résultat",
      "empty": "Aucun calcul enregistré pour ce cycle.",
      "select-cycle": "Sélectionnez un cycle pour consulter ses calculs enregistrés.",
      "loading": "Chargement des calculs…",
      "load-error": "Les calculs n’ont pas pu être chargés. Réessayez.",
      "retry": "Réessayer",
      "pending": "Ce calcul est encore en cours. Actualisez le résultat plus tard.",
      "calculating": "Importation des aliments et calcul de l’empreinte carbone…",
      "result-failed": "Ce calcul a échoué. Vérifiez les conditions dans le panneau de calcul, puis réessayez. Si le problème persiste, contactez votre conseiller.",
      "attempt-failed": "La dernière tentative a échoué. Vérifiez les conditions ci-dessous, puis réessayez. Les résultats enregistrés restent disponibles.",
      "status": {
        "complete": "Calculé",
        "pending": "En cours",
        "failed": "Échec"
      }
    },
    "readiness": {
      "view-details": "Afficher les données des aliments",
      "requirements-met": "conditions remplies",
      "title": "Conditions",
      "checking": "Vérification des données requises…",
      "error": "Impossible de vérifier les données requises. Réessayez.",
      "ready": "Données requises complètes.",
      "blocked": "Complétez les éléments ci-dessous avant le calcul.",
      "complete": "Complet",
      "action-required": "Action requise",
      "edit-arrivals": "Modifier les mises en place",
      "edit-departures": "Modifier les sorties",
      "edit-resources": "Modifier l’énergie par an",
      "edit-bedding": "Modifier la litière",
      "advisor": "Contactez votre conseiller pour corriger ces données. Transmettez les informations sur le produit et la livraison ci-dessus.",
      "disclaimer": "Cette vérification porte sur les données requises. Sustell peut encore refuser le calcul.",
      "recheck": "Vérifier à nouveau",
      "calculation-failed": "Sustell n’a pas pu calculer cette empreinte carbone. Vérifiez les conditions ci-dessous et réessayez. Si le problème persiste, contactez votre conseiller.",
      "requirements": {
        "cycle": "Mises en place, sorties et dates valides",
        "farm-resources": "Énergie pour chaque année requise",
        "bedding": "Données de litière",
        "feeds": "Valeurs nutritionnelles et émissions des aliments"
      },
      "arrival-weight": "Poids moyen de mise en place par poussin",
      "departure-weight": "Poids moyen de sortie par poussin",
      "issues": {
        "feeds-missing": "Enregistrez la consommation d’aliments composés dans le bilan alimentaire de ce lot.",
        "arrivals-missing": "Enregistrez les mises en place des poussins.",
        "departures-missing": "Enregistrez les sorties.",
        "cycle-dates-invalid": "Corrigez les dates du cycle, des mises en place et des sorties.",
        "arrival-data-invalid": "Saisissez un nombre positif de poussins et un poids de mise en place en grammes par poussin.",
        "departure-data-invalid": "Saisissez un nombre positif de poussins et un poids total de sortie en kg.",
        "departure-weight-below-arrival": "Le poids moyen de sortie doit être au moins égal au poids moyen de mise en place. Vérifiez le poids de mise en place en grammes par poussin, le poids total de sortie en kg et les nombres de poussins.",
        "farm-resources-missing": "Enregistrez la consommation d’énergie pour l’année",
        "cycle-dates-required": "Enregistrez des mises en place et sorties valides pour vérifier les années requises.",
        "bedding-type-missing": "Sélectionnez un type de litière.",
        "bedding-amount-missing": "Indiquez la quantité de litière.",
        "ship-to-missing": "Le lieu de livraison n’est pas lié au fournisseur d’aliments.",
        "delivery-missing": "Les données de livraison sont indisponibles.",
        "delivery-line-missing": "Les données du produit livré sont indisponibles.",
        "feed-data-invalid": "Les données requises de l’aliment sont absentes ou invalides.",
        "feed-settings-missing": "Les paramètres d’importation des aliments sont incomplets.",
        "farm-resources-not-calculated": "Enregistrez à nouveau les données d’énergie pour affecter la consommation à ce cycle."
      },
      "fields": {
        "Consumption": "Consommation d’aliments (kg), supérieure à zéro",
        "Co2Total": "Empreinte carbone totale",
        "Co2TotalMismatch": "Le total de CO₂ ne correspond pas à la somme des émissions biogéniques, fossiles et liées au changement d'utilisation des terres. Demandez à votre conseiller de corriger les données de l'aliment.",
        "Biogenic": "Émissions biogéniques",
        "FossilExcludingPeatEmissions": "Émissions fossiles hors tourbe",
        "FossilPeatEmissions": "Émissions de tourbe",
        "LandUseChange": "Émissions dues au changement d’utilisation des terres",
        "DryMatterAmount": "Teneur en matière sèche",
        "RoughProtein": "Teneur en protéines",
        "ProductIdentifier": "Référence produit"
      },
      "edit-feeds": "Modifier le bilan alimentaire",
      "edit-cycle": "Modifier le cycle"
    },
    "sustainability": "Durabilité",
    "farm-resources": "Énergie par an",
    "carbon-footprint": "Empreinte CO2",
    "add-farm-resources": "Ajouter des ressources agricoles",
    "confirm-delete-farm-resource": "Supprimer la ressource agricole?",
    "farm-resource-deleted": "Ressource agricole supprimée",
    "farm-resource-saved": "Ressource agricole enregistrée",
    "year": "Année",
    "farm-settings-saved": "Paramètres de la ferme enregistrés",
    "farm-settings-enable-co2-calculation": "Activer les calculs de CO2 pour cette ferme",
    "resource": {
      "electricity": "Électricité (kWh)",
      "electricity-photovoltaic": "Électricité Solaire (kWh)",
      "electricity-wind": "Électricité Éolienne (kWh)",
      "natural-gas": "Gaz naturel (m³)",
      "diesel": "Diesel (L)",
      "gasoline": "Essence (L)",
      "coal": "Charbon (KG)",
      "propane-lpg": "Propane / GPL (L)",
      "water": "Eau (m³)",
      "cycle-start-date": "Date de début",
      "cycle-end-date": "Date de fin",
      "status": "Statut",
      "statuses": {
        "complete": "Complet",
        "partial": "Incomplet"
      },
      "water-error": "L'eau doit être un nombre positif",
      "electricity-error": "L'électricité doit être un nombre positif",
      "electricity-photovoltaic-error": "L'électricité solaire doit être un nombre positif",
      "electricity-wind-error": "L'électricité éolienne doit être un nombre positif",
      "natural-gas-error": "Le gaz naturel doit être un nombre positif",
      "diesel-error": "Le diesel doit être un nombre positif",
      "gasoline-error": "L'essence doit être un nombre positif",
      "propane-lpg-error": "Le propane / GPL doit être un nombre positif",
      "coal-error": "Le charbon doit être un nombre positif"
    },
    "farm-resources-title": "Consommation d'énergie par an",
    "cycle-resources": "Consommation d’énergie par cycle",
    "value": "Valeur poids vif (kg CO2eq / kg poids corporel)",
    "notification-title": "Informations importantes sur les calculs de CO2",
    "notification-description": "Le calcul de l’empreinte carbone est réalisé à l’aide du logiciel d’ACV Sustell. Il repose sur les calculs des émissions de CO2 liées à l’alimentation, conformément à l’instruction Nevedi actuelle. Pour effectuer un calcul correct, toutes les données doivent être saisies de manière complète, telles que les <b>résultats techniques d’un lot, y compris la production, le départ/l’abattage et la consommation d’énergie.</b>\nLes valeurs affichées peuvent être sujettes à modification en raison de l’évolution des connaissances climatiques et des changements ultérieurs dans les systèmes de calcul, ainsi que des évolutions législatives, réglementaires ou des normes applicables. Bien que les informations présentées ici aient été compilées avec soin, aucun droit ne peut en être tiré.",
    "action-text-close": "Cacher",
    "action-text-open": "Montrer",
    "farm-resources-not-complete": "Les ressources du cycle ne sont pas complètes.",
    "bedding-type-required": "Le type de literie est requis pour le cycle.",
    "bedding-amount-required": "Le montant de la literie est nécessaire pour le cycle.",
    "start-calculation": "Commencer à calculer le CO2",
    "refresh-carbon-footprint": "Actualiser l'empreinte CO2",
    "carbon-footprint-title-error": "Erreur de calcul de l'empreinte carbone",
    "carbon-footprint-title": "Calcul de l’empreinte carbone",
    "carbon-footprint-text": "Le calcul de l’empreinte carbone va commencer. Veuillez patienter pendant que le processus se termine (environ 1 minute).",
    "carbon-footprint-refresh-error-title": "Impossible d'actualiser l'empreinte carbone",
    "carbon-footprint-refresh-error-text": "Nous n'avons pas pu actualiser l'empreinte carbone. Veuillez réessayer dans un instant."
  },
  "bedding-type": "Type de litière",
  "bedding-types": {
    "NoBedding": "Pas de litière",
    "BarleyStraw": "Paille d’orge",
    "MaizeStover": "Résidus de maïs",
    "OatStraw": "Paille d'avoine",
    "SawDust": "Sciure de bois",
    "SunflowerHusk": "Coque de tournesol",
    "WheatStraw": "Paille de blé",
    "Woodshavings": "Copeaux de bois"
  },
  "bedding-amount": "Quantité de litière",
  "bedding-amount-error": "La quantité de litière doit être un nombre positif",
  "transport-distance": "Transport depuis l'écloserie",
  "transport-distance-error": "Le transport de l'éleveur doit être un nombre compris entre 0 et 1000",
  "time-in-free-range": "Temps présent en plein air",
  "time-in-free-range-error": "Temps présent en plein air doit etre un nombre entre 0 et 100",
  "general-settings-error": "Une erreur s'est produite lors de la récupération des paramètres pour PoultryNEXT.",
  "tenants": {
    "Agrifirm": "agrifirm",
    "Agravis": "agravis"
  }
}
